// Simple pub/sub to relay credit updates from axios to Redux without circular imports
const subscribers = new Set();

export function subscribeCredits(listener) {
  subscribers.add(listener);
  return () => subscribers.delete(listener);
}

export function publishCredits(credits) {
  subscribers.forEach((fn) => {
    try { fn(credits); } catch {}
  });
}
